export const OBJECT_TYPE_DOMAIN = 'Domain'
export const OBJECT_TYPE_EMAIL = 'EMail'
export const OBJECT_TYPE_CONTACT = 'Contact'
export const OBJECT_TYPE_VALUES = [OBJECT_TYPE_DOMAIN, OBJECT_TYPE_EMAIL, OBJECT_TYPE_CONTACT]
export const OBJECT_TYPE_DEFAILT_VALUE = OBJECT_TYPE_DOMAIN
